const siteLoaderTheme = {
    loader: {
        container: {
            zIndex: 3,
        },
    },
};

export default siteLoaderTheme;
